import configureStore from './configureStore';

const { store, persistor, cache } = configureStore();

export { store, persistor, cache };
